import { withValidation } from "./WithValidation";
import * as propTypes from "./prop-types";

const hocs = {
  propTypes,
  withValidation
};

export default hocs;
